import React from "react";
import InputFactory from "../../../components/InputFactory";
import { findObjectUseCase } from "../../../usecases/object";

export default function FormInput({ sections, onChange, userInfo }) {
  return (
    <div className="d-flex flex-column gap-5">
      {sections.map((section) => {
        return (
          <div key={section.name}>
            <h4 className="fw-bold text-primary">{section.name}</h4>
            <hr
              className="pb-2"
              style={{ borderTop: "1px solid rgba(0, 0, 0, .2)" }}
            />
            <div className="d-flex flex-column gap-3">
              {Object.keys(section.fields).map((key) => {
                const { type, ...options } = section.fields[key];
                if (key === "roles") return null;

                return (
                  <div className={options.col} key={key}>
                    <label
                      className="form-label fw-semibold"
                      style={{ fontSize: "0.875rem" }}
                    >
                      {options.label}
                      {options.required ||
                      options._required ||
                      options.label === "First Name" ||
                      options.label === "Last Name" ||
                      options.label === "Mobile Number" ||
                      options.label === "Username" ||
                      options.label === "Affiliate" ||
                      // options.label === "Branch" ||
                      options.label === "Area Head Manager" ||
                      options.label === "Area Head Manager Contact" ||
                      options.label === "Position" ||
                      options.label === "Department" ? (
                        <span className="text-danger ms-1">*</span>
                      ) : null}
                    </label>
                    <InputFactory
                      field={key}
                      key={key}
                      object={userInfo}
                      type={type}
                      onChange={onChange}
                      {...options}
                    />
                  </div>
                );
              })}
              {section.name === "Login Information" && (
                <div className="col" key="confirmPassword">
                  <label
                    className="form-label fw-semibold"
                    style={{ fontSize: "0.875rem" }}
                  >
                    Confirm Password
                    <span className="text-danger ms-1">*</span>
                  </label>
                  <InputFactory
                    field="confirmPassword"
                    key="confirmPassword"
                    object={userInfo}
                    type="Password"
                    placeholder="Minimum 8 characters"
                    onChange={onChange}
                    required
                  />
                </div>
              )}
              {/* {section.name === "Employment Details" && (
                <div
                  className="term-check d-flex gap-2"
                  style={{ fontSize: "12px" }}
                >
                  <input
                    className="term-check-input mb-3"
                    type="checkbox"
                    id="terms"
                    required
                    checked={userInfo.terms || false}
                    // onChange={(e)=> onChange(e.target.checked,"terms")}
                  />
                  <label className="term-check-label" htmlFor="terms">
                    By submitting this form, you agree to our
                    <br />
                    <a href="/terms">Terms and Conditions</a>
                  </label>
                </div>
              )} */}
            </div>
          </div>
        );
      })}
    </div>
  );
}
